import type { AxiosError } from 'axios';

export interface ApiFieldErrors {
  /** Mensagem geral do backend (ou fallback) */
  message: string;
  /** 1ª mensagem por campo, chaveado pelo path do backend (ex: "address.street") */
  fieldErrors: Record<string, string>;
  hasFieldErrors: boolean;
}

const FALLBACK_MESSAGE = 'Erro ao salvar. Tente novamente.';

/**
 * Extrai erros de validação estruturados (422 { message, errors }) de um erro
 * axios. Padrão da plataforma: usar no catch de submits junto com
 * `_handleErrorLocally` no request (suprime o toast global cru) — ver spec
 * 2026-08-05-friendly-validation-errors.
 */
export function extractApiFieldErrors(err: unknown): ApiFieldErrors {
  if (err && typeof err === 'object' && 'response' in err) {
    const data = (err as AxiosError).response?.data as
      | { message?: string; errors?: Record<string, string[]> }
      | undefined;
    const fieldErrors: Record<string, string> = {};
    if (data?.errors) {
      for (const [path, messages] of Object.entries(data.errors)) {
        if (messages && messages.length > 0) fieldErrors[path] = messages[0];
      }
    }
    return {
      message: data?.message || FALLBACK_MESSAGE,
      fieldErrors,
      hasFieldErrors: Object.keys(fieldErrors).length > 0,
    };
  }
  return {
    message: err instanceof Error ? err.message : FALLBACK_MESSAGE,
    fieldErrors: {},
    hasFieldErrors: false,
  };
}
